import { cleanAxios } from '~/axios'

import { type VerifyMFACodeResult } from './verify-MFA-email-code.service'

export async function verifyMFAMessageCode({
  phoneNumber,
  code,
  rememberMe,
  accessToken,
}: {
  phoneNumber: string
  code: string
  rememberMe: boolean
  accessToken: string
}) {
  return await cleanAxios.post<{
    data: { verifyMFAMessageCode: VerifyMFACodeResult }
  }>(
    '/graphql',
    {
      query:
        'query verifyMFAMessageCode($phoneNumber: String!, $code: String!, $rememberMe: String!) { verifyMFAMessageCode(phoneNumber: $phoneNumber, code: $code, rememberMe: $rememberMe) { successful content } }',
      variables: { phoneNumber, code, rememberMe: rememberMe ? 'yes' : 'no' },
    },
    { headers: { Authorization: `Bearer ${accessToken}` } },
  )
}
